import isEmpty from 'lodash/isEmpty'

const addKeyTokens = (tokens, key, lastChar) => {
  tokens.push({ type: 'key', value: JSON.stringify(key) })
  tokens.push({ type: 'symbols', value: ': ' })
}

const addValueTokens = (tokens, value, lastChar, isArrayElement) => {
  const valueType = typeof value
  if (valueType === 'number' || valueType === 'string' || valueType === 'boolean') {
    tokens.push({ type: valueType, value: JSON.stringify(value) })
  } else if (value === null) {
    tokens.push({ type: 'null', value: 'null' })
  // add '{' (or '[')) for lines like
  //  "key": {
  } else if (!isArrayElement && valueType === 'object' && (lastChar === '{' || lastChar === '[')) {
    tokens.push({ type: 'symbols', value: lastChar })
  // for [] and {} elements of objects and arrays
  } else if (valueType === 'object' && isEmpty(value)) {
    tokens.push({ type: 'symbols', value: JSON.stringify(value) })
  }
}

// prepare array of lines in this form:
//   {[
//     indentation: 1,
//     tokens: [
//       // for line: "tickets: ["
//       {type: 'key', value: '"tickets"'},
//       {type: 'symbols', value: ': '},
//       {type: 'symbols', value: '['},
//     ], ...
//   ]}
// token types: 'key', 'symbols', 'number', 'string', 'boolean', 'null'
export const getJsonLinesWithTokens = (jsonObject) => {
  // early exit for primitive types and null
  if (typeof jsonObject !== 'object' || jsonObject === null) {
    return ([{
      indentation: 0,
      tokens: [{
        type: jsonObject === null ? 'null' : typeof jsonObject,
        value: JSON.stringify(jsonObject),
      }],
    }])
  }

  const res = []
  // store here the stack of objects/arrays indentations (e.g. ['{', '[', '{', '{', ... ])
  // to detect elements of array and hide their keys
  const parentsStack = []
  // store here keys and original values so that we don't need to parse them
  const jsonKeysAndValues = []
  const replacer = (key, value) => {
    if (key) {
      jsonKeysAndValues.push({ key: key, value: value })
    }
    return value
  }

  let relatedKeyIndex = 0
  const formattedJson = JSON.stringify(jsonObject, replacer, 1)
  const formattedJsonLines = formattedJson.split('\n')

  formattedJsonLines.forEach((origLine) => {
    const indentation = origLine.search(/\S/)
    const line = origLine.trim()
    const firstChar = line.at(0)
    const lastChar = line.at(-1)
    let keyValue
    const tokens = []
    const isArrayElement = parentsStack.at(-1) === '['

    if (line === '{' || line === '[' ||
      (indentation === 0 && (line === '[]' || line === '{}'))) {
      tokens.push({ type: 'symbols', value: line })
    }

    // if we have object or array key, add related tokens
    if (indentation > 0 && firstChar !== ']' && firstChar !== '}') {
      keyValue = jsonKeysAndValues[relatedKeyIndex]
      if (!isArrayElement) {
        addKeyTokens(tokens, keyValue.key)
      }
      addValueTokens(tokens, keyValue.value, lastChar, isArrayElement)
      relatedKeyIndex++
    }

    if (firstChar === ']' || firstChar === '}') {
      tokens.push({ type: 'symbols', value: firstChar })
      parentsStack.pop()
    }

    if (lastChar === ',') {
      tokens.push({ type: 'symbols', value: ',' })
    }

    if (lastChar === '{' || lastChar === '[') {
      parentsStack.push(lastChar)
    }

    res.push({
      indentation: indentation,
      tokens: tokens,
    })
  })
  return res
}
